import { CommonModule } from "@angular/common";
import { AfterViewInit, Component, OnDestroy, TemplateRef, ViewChild } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatOptionModule } from "@angular/material/core";
import { MatDialog, MatDialogModule } from "@angular/material/dialog";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIcon } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatMenuModule } from "@angular/material/menu";
import { MatPaginator, MatPaginatorIntl, MatPaginatorModule, PageEvent } from "@angular/material/paginator";
import { MatSelectModule } from "@angular/material/select";
import { MatSidenavContainer } from "@angular/material/sidenav";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatSort, MatSortModule } from "@angular/material/sort";
import { MatRowDef, MatTableDataSource, MatTableModule } from "@angular/material/table";
import { MatTooltipModule } from "@angular/material/tooltip";
import { NgSelectModule } from "@ng-select/ng-select";
import { TranslocoModule } from "@ngneat/transloco";
import { CustomMatPaginatorIntl } from "app/mock-api/common/customPaginatorIntl";
import { SystemLatencyService } from "./system-latency.service";
import { ResponseLatencyModalComponent } from "./response-latency-modal/response-latency-modal.component";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { IPaginationResult, IRequestResult } from "app/common/interfaces";
import { CompanyAttributes, LogMiddlewareServiceAttributes, LogMiddlewareServiceDetailAttributes } from "@albatrosdeveloper/ave-models-package";
import { CompanyService } from "../../configuration/company/company.service.service";
import { LogStatusEnum } from "@albatrosdeveloper/ave-models-package/lib/enums";
import { LogsLatencyModalComponent } from "./logs-latency-modal/logs-latency-modal.component";
import { FilterComponent } from "app/common/components/filter/filter.component";
import { SearchService } from "app/layout/common/search-page/search-page.service";
import { Subscription } from "rxjs";
import { DatesFiltersComponent } from "../../filters/dates-filters/dates-filters.component";
import { StatusFiltersComponent } from "../../filters/status-filters/status-filters.component";
import { ConfigurationFiltersComponent } from "../../filters/configuration-filters/configuration-filters.component";
import { HoverMenuDirective } from "@fuse/directives/hover-menu/hover-menu.directive";
import { DateHelper } from "app/utils/date.helper";

import {
  SmartGridComponent,
  ColDef,
  GridConfig,
  PageChangedEvent,
  SortChangedEvent,
  GridReadyEvent,
} from 'app/shared/components/smart-grid';
import { DataSentLatencyComponent } from "../components/data-sent-latency/data-sent-latency.component";
import { DataReceivedLatencyComponent } from "../components/data-received-latency/data-received-latency.component";
import { DataStatusLatencyComponent } from "../components/data-status-latency/data-status-latency.component";
import { LatencyErrorsReportExport } from "../../assistant/delivery/loads/exports/reports/latency-errors.report";
import { LATENCY_ERRORS_EXPORT_ID, LATENCY_ERRORS_PROPERTIES, LATENCY_ERRORS_TITLE } from "../../assistant/delivery/loads/exports/reports/latency-errors.constants";
import { ExportDialogComponent } from "app/layout/export-overlay/dialog/export-dialog.component";
import { ExportOptions } from "app/layout/export-overlay";


@Component({
  selector: 'app-system-latency',
  standalone: true,
  templateUrl: './system-latency.component.html',
  styleUrl: './system-latency.component.scss',
  imports: [
    TranslocoModule,
    CommonModule,
    MatTableModule,
    MatDialogModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSortModule,
    MatPaginatorModule,
    MatIcon,
    MatSelectModule,
    MatOptionModule,
    MatTooltipModule,
    MatExpansionModule,
    MatMenuModule,
    MatButtonModule,
    MatRowDef,
    MatSidenavContainer,
    FormsModule,
    NgSelectModule,
    MatDatepickerModule,
    LogsLatencyModalComponent,
    FilterComponent,
    DatesFiltersComponent,
    StatusFiltersComponent,
    ConfigurationFiltersComponent,
    HoverMenuDirective,
    SmartGridComponent
  ],
  providers: [
    { provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl },
    LatencyErrorsReportExport
  ],
})

export class SystemLatencyComponent implements AfterViewInit, OnDestroy {
  logStatusEnum = LogStatusEnum;

  displayedColumns: string[] = ["result", "status", "code", "type", "dateStart", "dateEnd", "duration", "actions"];

  dataSource = new MatTableDataSource<LogMiddlewareServiceAttributes>([]);

  totalItems = 0;
  search: string = '';
  pageSize: number = 50;
  pageIndex: number = 1;
  sortActive: keyof LogMiddlewareServiceAttributes = "createdAt";
  sortDirection: "ASC" | "DESC" = "DESC";

  //detail
  totalDetailItems = 0;
  searchDetail: string = '';
  pageSizeDetail: number = 50;
  pageIndexDetail: number = 1;
  sortActiveDetail: keyof LogMiddlewareServiceDetailAttributes = "status";
  sortDirectionDetail: "ASC" | "DESC" = "ASC";

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild('logModal') logModal: TemplateRef<any>;

  companyList: CompanyAttributes[] = [];
  filter = {
    dateini: new Date(),
    dateend: new Date(),
    company: null
  }

  range = new FormGroup({
    start: new FormControl<Date | null>(new Date()),
    end: new FormControl<Date | null>(new Date()),
  });

  displayedColumnsDetail: string[] = ["documentIdentifier", "message", "dataSent", "dataRecieved", "status"]
  dataSourceDetail = new MatTableDataSource<LogMiddlewareServiceDetailAttributes>([]);

  //BUSCADOR
  searchSubscription: Subscription;

  form: FormGroup;

  selectedStatuses: [] = [];

  elementDetail = null;

  /**
     * Smart Grid: Handle grid ready event
     * Called when grid is fully initialized and rendered
     */
  onGridReady(event: GridReadyEvent<any>): void {
    // Auto-size all columns after grid is ready
    setTimeout(() => {
      event.api.autoSizeAllColumns();
    }, 100);
  }

  /**
   * Smart Grid: Handle page change event (API mode)
   */
  onPageChanged(event: PageChangedEvent): void {
    this.pageIndexDetail = event.pageIndex + 1;
    this.pageSizeDetail = event.pageSize;
    this.getListDetailLog(this.elementDetail);
  }

  /**
   * Smart Grid: Handle sort change event (API mode)
   */
  onSortChanged(event: SortChangedEvent<any>): void {
    if (event.sortStates.length > 0) {
      const sortState = event.sortStates[0];
      this.sortActive = sortState.field as any;
      this.sortDirection = sortState.direction.toUpperCase() as 'ASC' | 'DESC';
    } else {
      this.sortActiveDetail = 'status';
      this.sortDirection = 'DESC';
    }
    this.getListDetailLog(this.elementDetail);
  }

  /**
   * Smart Grid: Handle sort change event (API mode)
   */
  onSearchChanged(event): void {
    this.searchDetail = event.searchTerm;
    this.getListDetailLog(this.elementDetail);
  }

  columnDefsDetail: ColDef<any>[] = [
    {
      field: 'documentIdentifier',
      headerName: 'Identificador Documento',
      sortable: true,
    },
    {
      field: 'message',
      headerName: 'Mensaje',
      sortable: true,
    },
    {
      field: 'dataSent',
      headerName: 'Data Enviada',
      sortable: false,
      filterable: false,
      width: 150,
      cellRenderer: DataSentLatencyComponent,
      cellRendererParams: {
        onClick: (data) => {
          this.openLogDetailModal(data);
        }
      }
    },
    {
      field: 'dataRecieved',
      headerName: 'Data Recibida',
      sortable: false,
      filterable: false,
      width: 150,
      cellRenderer: DataReceivedLatencyComponent,
      cellRendererParams: {
        onClick: (data) => {
          this.openLogDetailModal(data);
        }
      }
    },
    {
      field: 'status',
      headerName: 'Estado',
      sortable: false,
      filterable: false,
      width: 150,
      cellRenderer: DataStatusLatencyComponent,
    }
  ];

  gridConfigDetail: GridConfig<any> = {
    emptyState: {
      message: 'No encontramos tus resultados!',
      showIcon: true,
    },
    pagination: {
      enabled: true,
      mode: 'api',
      pageSize: 50,
      pageSizeOptions: [50, 100, 150, 200],
      showPaginator: true,
    },
    sorting: {
      enabled: true,
      mode: 'api',
      multiColumn: false,
      defaultSort: [{ field: 'total' as any, direction: 'desc' }],
    },
    search: {
      enabled: true,
      mode: 'api'
    },
    columnFilters: {
      enabled: true,
      mode: 'local'
    },
    columnVisibility: {
      enabled: false,
    },
    selection: {
      enabled: false,
    },
    autoSizing: {
      enabled: true,
      includeHeaders: true,
      skipHidden: true,
      padding: 40,
    },
    styling: {
      maxHeight: '80vh',
      density: 'comfortable',
      fontSize: '12px',
      cellPaddingX: '3px',
      cellPaddingY: '0px',
    },
    settingsPanel: {
      enabled: true,
      position: 'right',
      enableColumnVisibility: true,
      enableDensity: false,
      enableExport: true,
      defaultDensity: 'comfortable',
    },
  };

  constructor(
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private readonly systemLatencyService: SystemLatencyService,
    private readonly companyService: CompanyService,
    private readonly searchService: SearchService,
    private fb: FormBuilder,
    private latencyErrorsReportExport: LatencyErrorsReportExport
  ) {
    let today = new Date();
    this.form = this.fb.group({
      start: [today],
      end: [today],
      companyId: [null]
    });
  }

  ngAfterViewInit(): void {
    this.onHandleSearch();
    this.getComboCompanies()
    this.onFilter();
  }

  onFilter() {
    this.range.valueChanges.subscribe((rangeValues) => {
      this.filter.dateini = rangeValues.start || this.filter.dateini;
      this.filter.dateend = rangeValues.end || this.filter.dateend;
    });

    this.findAllWithCount()
  }

  onClearFilter() {
    this.selectedStatuses = [];
    this.form.reset();
    this.onFilter()
  }

  applyFilter(filterValue: string) {
    this.pageIndex = 1
    this.search = filterValue
    this.findAllWithCount()
  }

  public onHandleSearch() {
    this.searchSubscription = this.searchService.searchTerm$
      .subscribe(term => {
        this.pageIndex = 1
        this.search = term
        this.findAllWithCount()
      });
  }

  findAllWithCount(): void {
    let options = { currentPage: this.pageIndex, limitPerPage: this.pageSize, search: this.search, sort: this.sortActive, sortDirection: this.sortDirection }

    const companyCodes = this.getSelectedCompanyCodes(this.filter.company ? [this.filter.company] : []);

    let date = {
      start: DateHelper.getStartOfDay(this.form.get("start")?.value), // Convertir a UTC
      end: DateHelper.getEndOfDay(this.form.get("end")?.value) ?? DateHelper.getEndOfDay(this.form.get("start")?.value) ?? null,     // Convertir a UTC
    };

    this.systemLatencyService.findAllWithCount(options, companyCodes, date, this.selectedStatuses).subscribe({
      next: (res: IPaginationResult<LogMiddlewareServiceAttributes>) => {
        this.dataSource.data = res?.data?.[0]?.data ?? [];
        this.totalItems = res?.data?.[0]?.pageInfo?.[0]?.total ?? 0;
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener registros", "Cerrar", { duration: 5000 });
      },
    });
  }

  getSelectedCompanyCodes(selectedCompanyIds: string[]): number[] {
    return selectedCompanyIds.map(
      (id) => this.companyList.find((group) => group._id.toString() === id)?.id
    );
  }

  changeSort(e) {
    this.sortActive = e.active
    this.sortDirection = e.direction
    this.findAllWithCount();
  }

  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    this.pageIndex = (event.pageIndex + 1);
    this.findAllWithCount();
  }

  formatDate(date: string | Date, includeTime?: boolean): string {
    if (date) {
      const d = new Date(date);
      const day = d.getDate().toString().padStart(2, '0');
      const month = (d.getMonth() + 1).toString().padStart(2, '0');
      const year = d.getFullYear();

      if (includeTime) {
        const hours = d.getHours().toString().padStart(2, '0');
        const minutes = d.getMinutes().toString().padStart(2, '0');
        const seconds = d.getSeconds().toString().padStart(2, '0');
        return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
      }
      return `${day}-${month}-${year}`;
    }
    return '--:--:--'
  }

  formatHour(date: string): string {
    if (date) {
      const d = new Date(date);
      const hours = d.getHours().toString().padStart(2, '0');
      const minutes = d.getMinutes().toString().padStart(2, '0');
      const seconds = d.getSeconds().toString().padStart(2, '0');
      return `${hours}:${minutes}:${seconds}`;
    }
    return '--:--:--'
  }

  formatMiliSeconds(ms: number): string {
    if (ms === undefined || ms < 0) {
      return "--:--:--";
    }

    const hours = Math.floor(ms / (1000 * 60 * 60)).toString().padStart(2, '0');
    const minutes = Math.floor((ms % (1000 * 60 * 60)) / (1000 * 60)).toString().padStart(2, '0');
    const seconds = Math.floor((ms % (1000 * 60)) / 1000).toString().padStart(2, '0');
    const milliseconds = ms % 1000;

    if (Number(seconds) === 0) { //hours === 0 && minutes === 0 && 
      return `${hours}:${minutes}:${seconds}.${milliseconds}`;
    }

    return `${hours}:${minutes}:${seconds}`;
  }

  openAnswerModal(element): void {
    const dialogRef = this.dialog.open(ResponseLatencyModalComponent, {
      //panelClass: ".form-modal-interlocutor",
      width: "400px",
      data: element,
      disableClose: true
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        //this.findAllWithCount();
      }
    });
  }

  openLogModal(element): void {

    this.getListDetailLog(element)
    this.dialog
      .open(this.logModal, {
        width: '90%',
        height: '95%',
        maxHeight: '1200px',
        data: element,
        disableClose: true
      })
      .afterClosed()
      .subscribe(result => {
      });
  }

  getListDetailLog(element): void {
    this.elementDetail = element;

    let options = { currentPage: this.pageIndexDetail, limitPerPage: this.pageSizeDetail, search: this.searchDetail, sort: this.sortActiveDetail, sortDirection: this.sortDirectionDetail }

    this.systemLatencyService.findAllDetailWithCount(options, element._id).subscribe({
      next: (res: IPaginationResult<LogMiddlewareServiceDetailAttributes>) => {
        this.dataSourceDetail.data = res?.data?.[0]?.data ?? [];
        this.totalDetailItems = res?.data?.[0]?.pageInfo?.[0]?.total ?? 0;
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener registros", "Cerrar", { duration: 5000 });
      },
    });
  }

  onExport(): void {
    let optionsFilters = {
      currentPage: this.pageIndexDetail,
      limitPerPage: this.pageSizeDetail,
      search: this.searchDetail,
      sort: this.sortActiveDetail,
      sortDirection: this.sortDirectionDetail,
    };

    if (!this.latencyErrorsReportExport.canStartTask(LATENCY_ERRORS_EXPORT_ID)) return;

    const dialogRef = this.dialog.open(ExportDialogComponent, {
      data: { title: LATENCY_ERRORS_TITLE },
    });

    dialogRef.afterClosed().subscribe((options: ExportOptions) => {
      if (options) {
        this.latencyErrorsReportExport.export(
          options.format,
          options.range,
          this.totalDetailItems,
          this.pageSizeDetail,
          this.pageIndexDetail,
          LATENCY_ERRORS_EXPORT_ID,
          LATENCY_ERRORS_TITLE,
          LATENCY_ERRORS_PROPERTIES,
          this.elementDetail,
          optionsFilters
        );
      }
    });
  }

  openLogDetailModal(element): void {
    const dialogRef = this.dialog.open(LogsLatencyModalComponent, {
      width: "400px",
      data: element,
      disableClose: true
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
      }
    });
  }


  private getComboCompanies(): void {
    this.companyService.findToComboBox().subscribe({
      next: (res: IRequestResult<CompanyAttributes[]>) => {
        this.companyList = res.data;
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener compañias.", "Cerrar", { duration: 5000 });
      }
    });
  }

  ngOnDestroy(): void {
    this.searchSubscription.unsubscribe();
  }
}